import { render, staticRenderFns } from "./SalarySlipDetail.vue?vue&type=template&id=1ea5a9a6&scoped=true&"
import script from "./SalarySlipDetail.vue?vue&type=script&lang=js&"
export * from "./SalarySlipDetail.vue?vue&type=script&lang=js&"
import style0 from "./SalarySlipDetail.vue?vue&type=style&index=0&id=1ea5a9a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea5a9a6",
  null
  
)

export default component.exports